import Axios from "axios"

export type AssistantPromotionAssetKind =
    | "customer_service_qr_code"
    | "producer_wecom_invite_qr_code"
    | "wholesale_wecom_invite_qr_code"
    | "retail_wecom_invite_qr_code"

interface AssistantPromotionAsset {
    kind?: string
    configured?: boolean
    url?: string
}

interface AssistantPromotionResponse {
    data?: {
        assets?: AssistantPromotionAsset[];
    }
}

export interface AssistantPromotionImages {
    customerServiceQrCode?: string
    wecomInviteQrCode?: string
}

export const getAssistantPromotionApiBaseUrl = (
    hostname = typeof window === "undefined" ? "" : window.location.hostname
) =>
    hostname.endsWith(".senguo.cc")
        ? "https://ai-platform-api.senguo.cc"
        : "https://ai-platform-apitest.senguo.me"

export const AI_ASSISTANT_PROMOTION_URL = `${getAssistantPromotionApiBaseUrl()}/api/v1/ai-assistant-promotion`

const getConfiguredAssetUrl = (
    assets: AssistantPromotionAsset[],
    kind: AssistantPromotionAssetKind
) => {
    const asset = assets.find(
        item => item.kind === kind && item.configured === true
    )
    const url = asset && asset.url
    return typeof url === "string" && url.trim() ? url.trim() : undefined
}

export const resolveAssistantPromotionImages = (
    response: AssistantPromotionResponse,
    wecomKind: AssistantPromotionAssetKind
): AssistantPromotionImages => {
    const assets =
        response.data && Array.isArray(response.data.assets)
            ? response.data.assets
            : []
    return {
        customerServiceQrCode: getConfiguredAssetUrl(
            assets,
            "customer_service_qr_code"
        ),
        wecomInviteQrCode: getConfiguredAssetUrl(assets, wecomKind)
    }
}

export const getAssistantPromotionImages = async (
    wecomKind: AssistantPromotionAssetKind
) => {
    const response = await Axios.get<AssistantPromotionResponse>(
        AI_ASSISTANT_PROMOTION_URL,
        {
            timeout: 5000,
            withCredentials: false
        }
    )
    return resolveAssistantPromotionImages(response.data, wecomKind)
}
